/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { ContactUs } from '../../components/ContactUs';
import { OtherServices } from '../../components/OtherServices';
import { useStartupState } from '../../Providers/StartupState';
import { baseUrlImg, handleGetData } from '../../Api';
import { Loading } from '../../components/Loading';
import { Capa } from '../../components/Capa';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import * as S from './style';

export const SolarEnergy = () => {
  const [data, setData] = useState(null);

  const { setTitle, setBgHeader } = useHeaderStates();
  const { token, setError, loading, setLoading } = useStartupState();

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/energiasolar/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  // A página tem a própria Capa: a faixa verde com o título, que o Header
  // desenha a partir do setTitle, fica desligada.
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  if (loading) {
    return <Loading />;
  } else {
    return (
      <div style={{ position: 'relative' }}>
        <Capa
          imagem={[data?.imagemHeader?.iv?.[0], data?.banner?.iv?.imagemBackground?.[0]]}
          titulo={data?.titulo?.iv}
        />
        {/* a foto deste bloco subiu para a Capa */}
        <S.Container>
          <S.ContentBannersBox>
            <ReactMarkdown
              className="ReactMarkdown"
              children={data?.banner?.iv?.conteudoMarkdown}
            />
            <img
              src={`${baseUrlImg}${data?.banner?.iv?.imagemSecundaria[0]}`}
              alt="Logo V alley"
            />
          </S.ContentBannersBox>
        </S.Container>
        <OtherServices
          servicesLinks={data?.cartoesServicos?.iv}
          marginTop={'-5rem'}
        />
        <ContactUs />
      </div>
    );
  }
};
